import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { getAdminSession, isAdminAuthenticated } from './utils/sessionUtils'

export default function PrivateRoute({ component: Component, ...rest }) {
    const { adminId, role, accessMode } = getAdminSession()

    return (
        <Route
            {...rest}
            render = {props => 
                isAdminAuthenticated() ? (
                    <Component {...props} adminId={adminId} role={role} accessMode={accessMode}/>
                ) : ( 
                    <Redirect to={{ pathname: '/login', state: {from: props.location} }}
                    />
                )
            }
        />
    )
}
